
import type { PropType } from 'vue'
import { defineComponent, ref, computed } from 'vue'

// > components <
import AccountTooltip from './AccountTooltip.vue'

// > composable <
import useTooltip from '@/modern/composable/useTooltip'
import useClickOutside from '@/modern/composable/useClickOutside'

export default defineComponent({
    components: {
        AccountTooltip
    },
    props: {
        username: {
            type: String,
            default: null,
        },
        role: {
            type: [String, null] as PropType<string | null>,
            default: null,
        }
    },
    emits: ['logout'],
    setup(_, { emit }) {
        const containerReference = ref<HTMLElement | null>(null)

        const { reference, tooltip, isVisible, x, y, strategy, open, close } = useTooltip({
            placement: 'bottom',
            strategy: 'absolute',
            offset: 8,
            autoPlacement: {
                allowedPlacements: ['bottom'],
            },
        })

        useClickOutside(containerReference, close)

        const onLogout = () => emit('logout')

        const containerWidth = computed(() => {
            if (containerReference.value) {
                return `${containerReference.value.clientWidth}px`
            }

            return 'max-content'
        })


        return {
            containerReference,
            reference,
            tooltip,
            isVisible,
            x,
            y,
            strategy,
            open,
            onLogout,
            containerWidth
        }
    }
})
